<template>
    <!-- Новий дизайн: банер застосунку внизу інформаційних сторінок. На комп'ютері — QR, він веде на /lutsk/application,
         а та сторінка сама відкриває App Store чи Google Play за телефоном. Праворуч — фірмова піца з меню -->
    <section class="bp-appban" aria-label="Мобільний застосунок">
        <div class="bp-appban__body">
            <h2 class="bp-appban__h">Завантажуй застосунок і замовляй ще швидше</h2>
            <p class="bp-appban__sub">5% кешбеку на перше замовлення і 3% — на всі наступні</p>
            <!-- Плашка як на банері «Про нас» (04.11): QR ліворуч, праворуч підпис і значки магазинів в один ряд -->
            <div class="bp-appban__row">
                <img class="bp-appban__qr" src="@/assets/qr-app.svg" alt="QR-код: завантажити застосунок" width="98" height="98">
                <span class="bp-appban__cap">Наведи камеру телефона</span>
                <div class="bp-appban__stores">
                    <a href="https://apps.apple.com/cy/app/black-pizza/id1498371417" target="_blank" rel="nofollow" aria-label="App Store" onclick="dataLayer.push({'event': 'clickAppStore'});">
                        <img src="@/assets/appstore-badge-uk-black.svg" alt="Завантажити в App Store">
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.oakmont.blackpizza" target="_blank" rel="nofollow" aria-label="Google Play" onclick="dataLayer.push({'event': 'clickGooglePlay'});">
                        <img src="@/assets/googleplay-badge-uk.webp" alt="Завантажити з Google Play">
                    </a>
                </div>
            </div>
        </div>
        <img v-if="pizza" class="bp-appban__pizza" :src="pizza.thumbnail" alt="">
    </section>
</template>

<script>
export default {
    data() {
        return {
            pizza: null
        }
    },

    // Фото — піца з позначкою is_black (зараз це Black Pizza), інакше перша піца з фото
    mounted() {
        this.$store.dispatch('getProducts').then(products => {
            const pizzas = (products || []).filter(p => p.is_pizza == 1 && p.is_hidden != 1 && p.thumbnail);
            this.pizza = pizzas.find(p => p.is_black == 1) || pizzas[0] || null;
        }).catch(() => {});
    }
}
</script>
